import { B as BxfCheckbox$1, d as defineCustomElement$1 } from './p-bb6d4032.js';

const BxfCheckbox = BxfCheckbox$1;
const defineCustomElement = defineCustomElement$1;

export { BxfCheckbox, defineCustomElement };
